module.exports = __webpack_public_path__ + "e83f81c64b01e988bca7069ff9a3ae06.pdf";